import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import PubSub, { topics } from '../../lib/pubsub';

import Top from '../navigation/top';
import ShipmentList from './list';

const initialState = {
    height: 100,
};

@observer
class Shipment extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    render(props = this.props) {
        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <ShipmentList {...props} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Shipment;



// WEBPACK FOOTER //
// ./components/shipments/index.js